import { Link } from "react-router-dom";
import { Star, ExternalLink } from "lucide-react";

const REVIEW_URL = "https://www.producthunt.com/products/leadgen-paste-ur-url-grow-ur-business/reviews/new";

const FOOTER_LINKS = [
  { to: "/contact",  label: "Contact Us" },
  { to: "/#pricing", label: "Pricing", external: true },
  { to: "/terms",    label: "Terms & Conditions" },
  { to: "/privacy",  label: "Privacy Policy" },
  { to: "/refunds",  label: "Cancellation & Refunds" },
  { to: "/shipping", label: "Shipping Policy" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-200 mt-24 no-print bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10">
          <div className="max-w-md">
            <div className="font-display font-black text-zinc-900 text-lg tracking-tight">
              LeadGen<span className="text-indigo-600">.</span>
            </div>
            <p className="text-sm text-zinc-500 mt-2">
              Tells you what to do next to grow — and gives you the assets to do it.
            </p>
            <a
              href={REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-leave-review-btn"
              className="btn-lift mt-5 inline-flex items-center gap-2 h-10 px-5 rounded-full bg-zinc-900 text-white text-sm font-medium hover:bg-indigo-600"
            >
              <Star className="h-4 w-4 fill-amber-400 text-amber-400" /> Leave a Review
              <ExternalLink className="h-3.5 w-3.5 opacity-70" />
            </a>
          </div>

          <nav aria-label="Footer" data-testid="footer-nav" className="flex flex-wrap gap-x-8 gap-y-2 text-sm">
            {FOOTER_LINKS.map((link) =>
              link.external ? (
                <a
                  key={link.to}
                  href={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="text-zinc-600 hover:text-indigo-600"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="text-zinc-600 hover:text-indigo-600"
                >
                  {link.label}
                </Link>
              )
            )}
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-zinc-100 flex flex-col sm:flex-row sm:justify-between gap-2 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} LeadGen. Built for founders, not agencies.</div>
          <div>Digital delivery · No physical shipping · Made in India</div>
        </div>
      </div>
    </footer>
  );
}
